import type { ComponentType, ReactNode } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import adminAssetUploadApplet from './components/AdminAssetUpload';
import adminUserManagementApplet from './components/AdminUserManagement';
import type { AppletAccessDeniedProps } from './components/AppletGuard';
import batchComicApplet from './components/BatchComic';
import batchGenerationApplet from './components/BatchGeneration';
import batchMascotApplet from './components/BatchMascot';
import bmmPrototypeApplet from './components/BmmPrototype';
import cartographerApplet from './components/Cartographer';
import motionEditorApplet from './components/MotionEditor';

export interface AppletLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

export interface AppletDashboardMetadata {
  /** Imported static image URL used by Dashboard create/admin cards. */
  imageSrc?: string;
  imageAlt?: string;
  /** Optional video preview URL used by Dashboard create/admin cards. */
  videoSrc?: string;
  /** Optional Dashboard-specific label. Falls back to AppletDefinition.label. */
  title?: string;
  /** Optional Dashboard-specific description. Falls back to AppletDefinition.description. */
  description?: string;
  /** Sort order inside Dashboard sections. */
  order?: number;
  /** Hide from the customer create grid while keeping routes available. */
  hideFromCreateGrid?: boolean;
  /** Optional badge, for example "Coming soon". */
  badge?: string;
  /** Renders the card visually disabled and prevents navigation. */
  disabled?: boolean;
}

export type AppletDefinition = {
  id: string;
  /** Canonical path (links, redirect). */
  path: string;
  /** All route paths for this applet. */
  paths: string[];
  label: string;
  description?: string;
  dashboard?: AppletDashboardMetadata;
  policy: Policy;
  component: ComponentType;
  /** Optional applet-owned shell for allowed and loading states. */
  layout?: ComponentType<AppletLayoutProps>;
  /** Optional applet-owned loading UI for guard loading states. */
  loading?: ComponentType;
  /** Optional applet-owned denied UI for guard access-denied states. */
  accessDenied?: ComponentType<AppletAccessDeniedProps>;
};

export const applets: AppletDefinition[] = [
  adminAssetUploadApplet,
  adminUserManagementApplet,
  batchComicApplet,
  batchGenerationApplet,
  batchMascotApplet,
  bmmPrototypeApplet,
  cartographerApplet,
  motionEditorApplet,
];
